import { combineEpics } from 'redux-observable';

import { loadManagers } from './loadManagers';
import { createManager } from './createManager';
import { editManager } from './editManager';

export default combineEpics(
  loadManagers,
  createManager,
  editManager,
);



// WEBPACK FOOTER //
// ./src/scenes/Managers/services/epics/index.ts